import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
    this.setState({ errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 max-w-md mx-auto">
          <div className="card bg-red-50 border-red-200">
            <h2 className="text-lg font-bold text-red-700 mb-2">Une erreur est survenue</h2>
            <p className="text-sm text-red-600 mb-2">{this.state.error?.message || 'Erreur inconnue'}</p>
            {this.state.error?.stack && (
              <pre className="text-xs text-red-400 overflow-auto max-h-40 mt-2 whitespace-pre-wrap">
                {this.state.error.stack}
              </pre>
            )}
            <button
              onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
              className="btn-primary mt-4"
            >
              Réessayer
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
